export default __webpack_public_path__ + "static/mymove-4037823f62300dd73f9d6e55430c0e93.png";